export const nextArrow = `<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve">
  <path style="fill:currentColor;stroke-miterlimit:10" d="m8.65 24.4 8.4-8.4-8.4-8.4 3.6-3.6 12 12-12 12z"/>
</svg>`;

export const prevArrow = `<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xml:space="preserve">
  <path style="fill:currentColor;stroke-miterlimit:10" d="m8.65 24.4 8.4-8.4-8.4-8.4 3.6-3.6 12 12-12 12z"/>
</svg>`;

if ( jQuery( '.gallery-slider.with-nav' ).length ) {
  jQuery( '.gallery-slider.with-nav' ).slick( {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    rows: 0,
    asNavFor: '.gallery-slider.nav'
  } );
}

if ( jQuery( '.gallery-slider.nav' ).length ) {
  jQuery( '.gallery-slider.nav' ).slick( {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    centerPadding: '0',
    rows: 0,
    focusOnSelect: true,
    asNavFor: '.gallery-slider.with-nav',
    prevArrow,
    nextArrow,
  } );
}

if ( jQuery( '.gallery-slider.with-nav' ).length ) {
  jQuery( '.gallery-slider.with-nav' ).slickLightbox( {
    src: 'href',
    itemSelector: '.image-slide a',
    prevArrow,
    nextArrow,
  } );
}
